import {TCommonModel} from '../common/t-common-model';
import {AutoMap} from '@automapper/classes';
import {FormField} from '../../../core/decorators/form-field.decorator';
import {Validators} from '@angular/forms';
import {UserLocalDataModel} from '../user-local-data.model';

export class SubmitVerificationCodeRequestModel extends TCommonModel {
  @FormField({
    default: '',
    readonly: true,
    validators: [Validators.required, Validators.email]
  })
  @AutoMap()
  email!: string;

  @FormField({
    default: '',
    validators: [Validators.required, Validators.maxLength(6), Validators.minLength(6)],
  })
  @AutoMap()
  code!: string;
}

export class SubmitVerificationCodeResponseModel {
  @AutoMap()
  doesUserExist!: boolean;

  @AutoMap()
  data!: UserLocalDataModel | null;
}
